<template>
  <div class="dialog-content">
    <v-list dense>
      <v-list-item-group color="primary" :value="selectedItem">
        <div class="full-width mb-2">
          <v-text-field
            v-model="search"
            class="search-field"
            :label="searchPlaceholder"
            prepend-inner-icon="icon-search"
            clearable
            outlined
            rounded
            :hide-details="true"
            @input="searchHandler"
          ></v-text-field>
        </div>
        <div class="dialog-content__no-data" v-if="!loader && !items.length">
          {{ $t("message.common.noData") }}
        </div>
        <template v-else>
          <v-radio-group v-model="selectedItem" class="list-group">
            <v-radio
              v-for="item in items"
              :key="item.id"
              :value="checkIsSelected(item)"
              class="list-group__item"
            >
              <template slot="label">
                <v-list-item>
                  <v-list-item-content>
                    <div class="list-group__label">{{ item.name }}</div>
                    <div v-if="showAddress" class="list-group__data">
                      <span v-if="item.formatted_address">{{
                        item.formatted_address
                      }}</span>
                      <span v-if="item.store_code">|</span>
                      <span v-if="item.store_code">
                        {{ $t("message.common.storeCode") }}:
                        {{ item.store_code }}
                      </span>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-radio>
          </v-radio-group>
        </template>
      </v-list-item-group>
    </v-list>

    <Pagination
      v-if="totalCount"
      class="flex-grow-1"
      key="pagination-facilities"
      :page="page"
      :per-page="perPage"
      :total-count="totalCount"
      :show-options="false"
      centered
      @change="$emit('change', { ...$event, searchValue: search })"
    ></Pagination>
  </div>
</template>

<script>
import Pagination from "@/components/List/Pagination";
import { debounce } from "@/helpers/helpers";

export default {
  name: "FacilitiesDialog",
  components: { Pagination },
  props: {
    items: {
      type: Array,
      required: true
    },
    searchPlaceholder: {
      type: String,
      required: true
    },
    page: {
      type: Number
    },
    perPage: {
      type: Number
    },
    showAddress: {
      type: Boolean,
      default: false
    },
    totalCount: {
      type: Number
    },
    loader: {
      type: Boolean,
      default: false
    },
    tab: {
      type: Number,
      required: true
    },
    selectedId: {
      type: [Number, String]
    }
  },
  data() {
    return {
      search: "",
      selectedItem: null
    };
  },
  watch: {
    selectedItem(current) {
      if (current.readOnly) return;

      this.$emit("select-item", { ...current, tab: this.tab });
    },
    tab() {
      this.search = "";
      this.selectedItem = null;
    }
  },
  methods: {
    checkIsSelected(item) {
      if (item.id == this.selectedId) {
        this.selectedItem = item;
        this.selectedItem.readOnly = true;
      }
      return item;
    },
    searchHandler: debounce(async function() {
      this.$emit("search-value", { page: 1, searchValue: this.search });
    }, 500)
  }
};
</script>
<style lang="scss" scoped>
.search-field {
  box-shadow: 0px 0px 30px rgba(54, 60, 86, 0.07);
}
.dialog-content {
  display: flex;
  flex-direction: column;

  &__no-data {
    text-align: center;
    padding: $spacing * 6;
  }
}

.list-group {
  overflow-y: auto;
  height: calc(100vh - 550px);
  max-height: 510px;

  &__data {
    margin-top: $spacing * 0.5;
    @include font-size(12px);

    & > span + span {
      margin-left: $spacing * 1.5;
    }
  }

  &__label {
    @include font-size(14px);
  }

  &__item {
    border-bottom: 1px solid $gray-200;
    margin: 0 !important;
    padding-left: $spacing * 1.2;

    ::v-deep.v-list-item__content {
      padding: $spacing * 2 0;
    }
  }
}
</style>
